module.exports = __webpack_public_path__ + "static/assets/e6065c892c2a4881ad14958df2e69afb.svg";